// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"767d7fbc","280":"a8569b70","298":"98e0b55c","350":"d03b2f67","428":"2c9431b2","628":"0811a015","696":"7cd77890","743":"9cf92cfc","751":"0e16a73e","879":"cded9fe7","906":"b37fb6dd","940":"10ba0190","973":"90269597"}[chunkId] + ".chunk.js";
};